import Layout from "../../pages/tideng/recall/Layout";
import Index from "../../pages/tideng/recall/index";
import AnniverSary from "../../pages/tideng/recall/anniversary";
import Info from "../../pages/tideng/recall/info";
import PC from "../../pages/tideng/recall/pc";

const base = "recall";

const routes = [{
    path: `/${base}`,
    component: Layout,
    redirect: `/${base}/anniversary`, // 初始页跳转
    children: [{
            path: `index`,
            name: `${base}-index`,
            component: Index
        },
        {
            path: `enter*`,
            name: `${base}-enter`,
            component: Index
        },
        {
            path: `anniversary*`,
            name: `${base}-anniversary`,
            component: AnniverSary
        },
        {
            path: `info*`,
            name: `${base}-info`,
            component: Info
        },
        {
            path: `pc*`,
            name: `${base}-pc`,
            component: PC
        }
    ]
}];

export default routes;


// WEBPACK FOOTER //
// ./src/router/tideng/recall.js